const initState = {
  popular: [],
  newGames: [],
  upcoming: [],
  searched: [],
  isLoading: true,
};

const gamesReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOADING_GAMES":
      return { ...state, isLoading: true };
    case "FETCH_GAMES":
      return {
        ...state,
        popular: action.payload.popular,
        upcoming: action.payload.upcoming,
        newGames: action.payload.new,
        isLoading: false,
      };
    case "FETCH_SEARCHED":
      return { ...state, searched: action.payload.searched };
    case "CLEAR_SEARCH":
      console.log("ahello");

      return { ...state, searched: [] };
    default:
      return { ...state };
  }
};

export default gamesReducer;
